import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

const CookieBannerContent = () => {
    const intl = useIntl()

    return (
        <>
            <FormattedMessage id="header.cookieContent" />{' '}
            <a
                href={`${intl.formatMessage({
                    id: 'footer.privacy.link',
                })}#5-cookies`}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
            >
                <FormattedMessage id="header.cookieLink" />
            </a>
        </>
    )
}

export default CookieBannerContent
